import React from "react";
import { getEntityFullName } from "../components/tools";
//import { DropdownButton, Dropdown } from 'react-bootstrap';
//import { FaSortUp, FaSortDown } from 'react-icons/fa'; //  FaTrashAlt, FaSave, FaExternalLinkAlt, FaFileUpload
//import { IconContext } from "react-icons";

export const LessonsList = ({ lessons, deleteLesson, activeLanguage, lessonActivationHandler }) => {

    console.log(lessons);

    return (
        <table className="Table">
            <thead>
                <tr className="TableBlock">
                    <th key="name" className="TableFirstLineBlock">Index</th>
                    <th key="lesson" className="TableFirstLineBlock">Lesson</th>
                    <th key="content" className="TableFirstLineBlock">Actions</th>
                </tr>
            </thead>

            <tbody>
                {lessons?.length ? (
                    lessons
                        .map((lesson, index, array) => {
                            return <tr key={lesson.id}>
                                <td className='TableSecondLineBlock text-center text-white'>{index + 1}</td>
                                <td className='TableSecondLineBlock text-center text-white'>
                                    {getEntityFullName(lesson, activeLanguage)}
                                </td>
                                <td className="TableSecondLineBlock text-center">
                                    {
                                        lesson.active === 1 ?
                                            <img
                                                src="/img/Eye.png"
                                                alt="lesson is active" onClick={() => {
                                                    lessonActivationHandler(lesson, 0);
                                                }}
                                                className="mx-1 TableSecondLineImg"
                                            /> :
                                            <img
                                                src="/img/Lock.png"
                                                alt="lesson is locked" onClick={() => {
                                                    lessonActivationHandler(lesson, 1);
                                                }}
                                                className="mx-1 TableSecondLineImg"
                                            />
                                    }
                                    <img
                                        src="/img/TrashB.png"
                                        alt="" onClick={() => {
                                            if (window.confirm("Remove this lessons from this team?")) {
                                                deleteLesson(lesson);
                                            }
                                        }}
                                        className="text-danger mx-1 TableSecondLineImg"
                                    />
                                </td>
                            </tr>
                        })
                ) : (
                    <tr className="NoElementsText"><td colSpan={2} className="text-center">No Lessons</td></tr>
                )}
            </tbody>
        </table >
    )
};